export const adjustBasketballChartStats = (home, away) => {
  if (!home || !away) {
    return []
  }

  const chartStatsProps = ['fieldgoal', 'fieldgoal_threepoints', 'free_throws']
  const adjustedStats = []

  for (const statProp of chartStatsProps) {
    const percentageStats = _adjustPercentStats(home[statProp].value, away[statProp].value)

    adjustedStats.push({
      uuid: statProp,
      home: {
        label: home[statProp].value,
        additionalLabel: percentageStats.homePercent,
        value: percentageStats.homeMade
      },
      away: {
        label: away[statProp].value,
        additionalLabel: percentageStats.awayPercent,
        value: percentageStats.awayMade
      },
      title: home[statProp].label
    })
  }

  return adjustedStats
}

export const adjustBasketballTableStats = (home, away) => {
  if (!home || !away) {
    return []
  }

  const tableStatsProps = ['rebounds', 'fouls_committed', 'assists', 'blocks', 'steals', 'turnover']

  return tableStatsProps.map(statProp => ({
    uuid: statProp,
    home: home[statProp].value,
    away: away[statProp].value,
    title: home[statProp].label
  }))
}

export const _adjustPercentStats = (homeStatValue, awayStatValue) => {
  const [homeMade, homeAttempted] = homeStatValue.split('/').map(Number)
  const [awayMade, awayAttempted] = awayStatValue.split('/').map(Number)

  const totalMade = homeMade + awayMade

  return {
    homeMade: (homeMade / totalMade) * 100,
    awayMade: (awayMade / totalMade) * 100,

    homePercent: `${((homeMade / homeAttempted) * 100).toFixed(1)}%`,
    awayPercent: `${((awayMade / awayAttempted) * 100).toFixed(1)}%`
  }
}
